import { useRef } from 'react';
import type { GridSize } from 'types/capi/plp';

import ArrowIcon from '~/assets/icons/Arrow';
import useHasScrolledIntoView from '~/hooks/useHasScrolledIntoView';

const cardWidths: Record<GridSize, string> = {
  large: 'desktop:w-[calc((100%-3rem)/3)]',
  small: 'desktop:w-[calc((100%-4.5rem)/4)]'
};

export default function NotificationTooltip({
  className,
  gridSize
}: {
  className?: string;
  gridSize: GridSize;
}) {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const hasScrolledIntoView = useHasScrolledIntoView(tooltipRef);

  return (
    <div ref={tooltipRef} className={`w-full md:w-fit ${cardWidths[gridSize]}`}>
      {hasScrolledIntoView && (
        <div
          className={`flex h-8 items-center justify-between gap-2 bg-white/90 bg-[linear-gradient(0deg,_rgba(209,_159,_244,_0.16)_0%,_rgba(209,_159,_244,_0.16)_100%)] px-2 py-1.5 md:pr-4 ${className} animate-slide-delay opacity-0`}
        >
          <div className="text-xs leading-5 text-purple-hola">
            Tap the bell to get a release alert
          </div>
          <div className="rotate-270">
            <ArrowIcon fill="#8907e7" className="animate-pulse" />
          </div>
        </div>
      )}
    </div>
  );
}
